import { Dispatch, SetStateAction, useCallback, useState } from 'react';
import { FieldValues, UseFormSetValue } from 'react-hook-form';
import { UseFormResetField } from 'react-hook-form/dist/types/form';

import {
	DefaultOptionsInterface, GroupSelectOptionsInterface,
} from '@components/common';

import { generateDefaultValues } from '@components/Kpi/Parameters/utils';

import { EFormFields } from '@enums/kpi-api';

export const usePresetTechnologySelectorsLogic = ({
	setIsDirtyPresetForm,
	setValue,
	resetField,
}: {
	setIsDirtyPresetForm: Dispatch<SetStateAction<boolean>>;
	setValue:  UseFormSetValue<FieldValues>;
	resetField: UseFormResetField<FieldValues>;
}) => {
	const [defaultValueT_5G, setDefaultValueT_5G] = useState<Array<DefaultOptionsInterface>>([]);

	const onChangeSitesT_5G = useCallback((
		values: Array<GroupSelectOptionsInterface>,
		isUpdateDirty: boolean = true,
	) => {
		setValue(EFormFields.sitesT_5G, values);
		setDefaultValueT_5G(generateDefaultValues(values));

		setIsDirtyPresetForm(isUpdateDirty);
	}, [setValue, setIsDirtyPresetForm]);

	const resetT_5G = useCallback(() => {
		setDefaultValueT_5G([]);
		resetField(EFormFields.sitesT_5G);
	}, [resetField]);

	return {
		defaultValueT_5G,
		onChangeSitesT_5G,
		resetT_5G,
	};
};
